// 確認メールアドレスチェック
const email_conf = {
    // ルールを書くときに使う引数。
    params: ['email'],
    
    // バリデーションロジック
    validate(value, { email }) {
        return ( value && value != email ) ? false : true; // or false true: バリデーションエラーなし, false: バリデーションエラーあり
    },
    
    // バリデーションエラーメッセージ
    message(field){
        return `※${field}が一致していません。`;
    },
};

// パスワードの入力値チェック（ 0-9 a-z A-Z ! " # $ % & ' ( ) * , . / : ; < = > ? @ [ ] ^ _ ` { | } ~ ）
const password = {
    // ルールを書くときに使う引数。
    params: [],
    
    // バリデーションロジック
    validate(value) {
        var re = /^[0-9a-zA-Z\-!"#$%&'()*,./:;<=>?@[\]^_`{|}~]*$/;
        return re.test(String(value)); // true: バリデーションエラーなし, false: バリデーションエラーあり
    },
    
    // バリデーションエラーメッセージ
    message(){
        return `※使用できない文字が使われています。`
    },
};

// 半角英数字記号
const alpha_num_symbol = {
    // ルールを書くときに使う引数。
    params: [{
        name: 'target',
        isTarget: true
    }],

    // バリデーションロジック
    validate(value, { target }) {
        const regex = new RegExp(/^[a-zA-Z0-9!-/:-@¥[-`{-~]*$/);
        return regex.test(String(target)); // true: バリデーションエラーなし, false: バリデーションエラーあり
    },

    // バリデーションエラーメッセージ
    message(field){
        return `${field}は半角英数字記号で入力してください`;
    },
};

const ivs_str_max = {
    // ルールを書くときに使う引数。
    params: ['max'],

    // バリデーションロジック
    validate(value, { max }) {
        let graphemesplit = require("graphemesplit")
        let strList = value ? graphemesplit(value) : [];
        return strList.length <= max;
    },

    // バリデーションエラーメッセージ
    message(field, { max }){
        return `${field}は${max}文字以内でご入力ください`;
    },
};

const seal_ivs_str_max = {
    // ルールを書くときに使う引数。
    params: ['obj'],

    // バリデーションロジック
    validate(value, { obj }) {
        let error = true
        let graphemesplit = require("graphemesplit")
        var splitedText = obj.value != null?obj.value.split('\n'):[];
        if(splitedText.length > obj.max){
            error = false;
        }

        splitedText.every((item) => {
            let textList = item ? graphemesplit(item) : [];
            if(textList.length > obj.max){
                error = false;
                return false
            }else{
                return true
            }
        })
        return error
    },

    // バリデーションエラーメッセージ
    message(field, { obj }){
            let message = ""
            let graphemesplit = require("graphemesplit")
            var splitedText = obj.value != null?obj.value.split('\n'):[];
            if(splitedText.length > obj.max){
                message = `${obj.max}行以内で入力してください`;
            }

            var text = `1行につき${obj.max}文字以内で入力してください`
            splitedText.every((item) => {
                let textList = item ? graphemesplit(item) : [];
                if(textList.length > obj.max){
                    message = message?message+"<br>"+text:text;
                    return false
                }else{
                    return true
                }
            })
        return message;
    },
};

const file_name_symbol = {
    // ルールを書くときに使う引数。
    params: [],

    // バリデーションロジック
    validate(value) {
        const regex = new RegExp(/[\\/:*?"<>|]+/);
        return (regex.test(String(value)) == false); // true: バリデーションエラーなし, false: バリデーションエラーあり
    },

    // バリデーションエラーメッセージ
    message(){
        return '次の文字はファイル名に使用できません　\/:*?"<>|';
    },
};

const file_name_dot = {
    // ルールを書くときに使う引数。
    params: [],

    // バリデーションロジック
    validate(value) {
        const regex = new RegExp(/^\./);
        return (regex.test(String(value)) == false); // true: バリデーションエラーなし, false: バリデーションエラーあり
    },

    // バリデーションエラーメッセージ
    message(){
        return '.（ドット）はファイル名の先頭に使用できません';
    },
};

// 定義
export {
    email_conf,
    password,
    alpha_num_symbol,
    ivs_str_max,
    seal_ivs_str_max,
    file_name_symbol,
    file_name_dot,
};